import React from 'react';
import cx from 'clsx';
import classes from './Container.module.scss';

interface ContainerProps extends React.HTMLProps<HTMLDivElement> {
  mainClass?: string;
}

export default function Container({
  className,
  mainClass,
  children,
  ...others
}: ContainerProps) {
  return (
    <div className={cx(classes.container, mainClass)} {...others}>
      <div className={cx(classes.content, className)}>
        {children}
      </div>
    </div>
  );
}

Container.displayName = '@ioa/lablocator/Container';